import React, { useMemo, useCallback } from 'react';

import Icon from 'monday-ui-react-core/dist/Icon';
import Delete from 'monday-ui-react-core/dist/icons/Delete';
import BillingInputComponent from '../../../../template-blocks/billing-input/billing-input-component';
import EditableInput from '../../../../template-blocks/editable-input/editable-input';
import billingInputTypes from '../../../../template-blocks/billing-input/billing-input-types';
import { isFixed } from '../../billing-items-service';

import './adjustment-item-component.scss';

const VALUE_TYPE = 'valueType';
const VALUE = 'value';

export default function AdjustmentItemComponent({
  previewMode,
  currency,
  currencySign,
  id,
  title,
  value,
  valueType,
  onAdjustmentValueChange,
  onAdjustmentDelete,
  onAdjustmentTitleChange,
  onTitleBlur,
  isNew,
}) {
  const adjustmentValue = value || 0;
  const adjustmentValueType = valueType || '';

  const adjustmentLabel = isFixed(adjustmentValueType) ? `${currencySign}${adjustmentValue}` : `${adjustmentValue}%`;

  const onValueTypeChange = useCallback(
    (fieldType, id, { data }) => {
      const rate = {
        id,
        value,
        valueType,
      };

      rate[fieldType] = data;

      onAdjustmentValueChange(rate);
    },
    [value, valueType, onAdjustmentValueChange]
  );

  const onInputBlur = useCallback(
    (newTitle) => {
      onAdjustmentTitleChange(id, newTitle);
      onTitleBlur();
    },
    [id, onAdjustmentTitleChange, onTitleBlur]
  );

  const titleToRender = useMemo(() => {
    if (!previewMode) {
      return <EditableInput editOnMount={isNew} value={title} onBlur={onInputBlur} />;
    }

    return <>{title}</>;
  }, [title, previewMode, onInputBlur, isNew]);

  return (
    <div className="adjustment-item-component">
      <div className="row adjustment-item pdf-row">
        <div className="label">{titleToRender}</div>
        {!previewMode && (
          <div className="input-wrapper">
            <BillingInputComponent
              id={id}
              previewMode={previewMode}
              withTitle={false}
              type={billingInputTypes.select}
              inputProps={currency.inputProps}
              value={adjustmentValueType}
              onChange={onValueTypeChange.bind(null, VALUE_TYPE)}
              clearable={false}
            />
          </div>
        )}
        <div className="input-wrapper">
          <BillingInputComponent
            id={id}
            previewMode={previewMode}
            withTitle={false}
            type={billingInputTypes.number}
            placeholder="0.00"
            value={adjustmentValue}
            label={adjustmentLabel}
            onChange={onValueTypeChange.bind(null, VALUE)}
          />
        </div>
        {!previewMode && (
          <Icon
            className="delete-adjustment-icon-wrapper"
            iconType={Icon.type.SVG}
            icon={Delete}
            iconSize={20}
            onClick={() => onAdjustmentDelete(id)}
          />
        )}
      </div>
    </div>
  );
}
